<script lang="ts">
import { formatBlogDate } from '$lib/utils/dates.js';
import { BLOG_NAME } from '../../../config/constants.js';
import { ERoutes } from '../../../config/enums.js';
import CardGridItem from '../../../stories/atoms/CardGridItem/CardGridItem.svelte';
import SectionHeader from '../../../stories/atoms/SectionHeader/SectionHeader.svelte';
import AuthorBio from '../../../stories/molecules/AuthorBio/AuthorBio.svelte';
import CardGrid from '../../../stories/molecules/CardGrid/CardGrid.svelte';
import Hero from '../../../stories/organisms/Hero/Hero.svelte';

// biome-ignore lint/suspicious/noExplicitAny: Data type from +page.server.js
let { data }: { data: any } = $props();
</script>

{#if data.headerImage}
    <Hero
        image={{
            src: data.headerImage,
            alt: data.authorInfo.name,
        }}
        mobileImage={{
            src: data.headerImageMobile,
            alt: data.authorInfo.name,
        }}
        content={BLOG_NAME}
        mastheadTextColour={'#fff'}
    />
{/if}

<div class="author-page">
    <div class="author-page__bio">
        <AuthorBio author={data.authorInfo} />
    </div>

    <div class="author-page__articles">
        <SectionHeader titleSize="h3" includeGutter={true}>
            Articles by {data.authorInfo.name}
        </SectionHeader>

        <CardGrid hasBorder={false} hasBottomMargin={false}>
            {#snippet children()}
                {#each data.authorPosts ?? [] as post (post.id)}
                    <CardGridItem
                        data-aos="fade-up"
                        class="builder-block"
                        to={`${ERoutes.TheWire}${post.data?.slug ?? ''}`}
                        title={post.name}
                        description={formatBlogDate(post.data?.date)}
                        image={{
                            src: post.data?.thumbnail,
                            altText: post.name,
                        }}
                    />
                {/each}
            {/snippet}
        </CardGrid>
    </div>
</div>

<style lang="scss">
    @use '/src/scss/global-constants/mq-config';
    @use 'sass-mq/mq' as *;

    .author-page {
        background: var(--colour-white);
        position: relative;
        z-index: 1;

        &__bio {
            padding-top: 4rem;

            @include mq($from: tablet) {
                padding-top: 8rem;
            }
        }

        &__articles {
            margin-top: 5rem;

            @include mq($from: tablet) {
                margin-top: 8rem;
            }

            :global(.section-header) {
                margin-bottom: 3rem;

                @include mq($from: tablet) {
                    margin-bottom: 4rem;
                }
            }
        }
    }
</style>
